import { ModalForm, type ProFormInstance } from '@ant-design/pro-components';
import { useRef } from 'react';
import type { FormScene, MyProColumn } from '../MyProTable';
import { TableFormItem } from './TableFormItem';

export type MyModalFormProps<T> = {
  open: boolean;
  initialValues?: Partial<T>;
  onFinish: (values: T) => Promise<any> | any;
  onCancel: () => void;
  columns: MyProColumn<T>[];
  tableTitle?: string;
};

export const MyModalForm = <T extends Record<string, any>>(
  props: MyModalFormProps<T>,
) => {
  const { open, initialValues, onFinish, onCancel, columns, tableTitle } =
    props;

  const scene: FormScene = initialValues ? 'edit' : 'create';
  const formRef = useRef<ProFormInstance>(undefined);

  const init = {
    // 把 createDefaultValue 合进去
    ...Object.fromEntries(
      columns
        .filter((c) => c.dataIndex && c.createDefaultValue !== undefined)
        .map((c) => [c.dataIndex as string, c.createDefaultValue]),
    ),
    status: initialValues?.status ?? 'enabled',
    createdAt: initialValues?.createdAt ?? new Date().toISOString(),
    ...initialValues,
  };

  return (
    <ModalForm<T>
      formRef={formRef}
      title={initialValues ? `编辑${tableTitle}` : `新建${tableTitle}`}
      open={open}
      modalProps={{ destroyOnClose: true, onCancel }}
      initialValues={init as any}
      onFinish={() => onFinish(formRef.current?.getFieldsValue(true) || {})} // 默认values只会返回有值的数据
      layout="horizontal"
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 18 }}
    >
      {TableFormItem(formRef, columns, scene, initialValues)}
    </ModalForm>
  );
};
